import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import detallePrecioStyles from '../compras/DetallePrecio.module.css'
import GenericSelect from '../reutilizables/genericSelect/GenericSelect'
import Precios from '../reutilizables/precios/Precios'
import * as domiciliosService from '../servicios/domiciliosService'
import styles from './DetalleImpuestos.module.css'

const TIPO_IMPUESTO_PERCEPCION = 'P'
const ALICUOTA_MAX = 100
const ESTADO_PERCEPCIONES_OK = 4
const ESTADO_PERCEPCIONES_NO_OK = 5

const generarIdTemporal = () => `new_${Date.now()}_${Math.random().toString().slice()}`

export const DetalleImpuestos = ({
  esVentas = false,
  filas = [],
  onChangeFilas,
  errores = {},
  usaImagen = false,
  pedidoItems = [],
  obtenerNetoItem,
  setErrores
}) => {
  const [provincias, setProvincias] = useState([])

  const obtenerProvincias = async () => {
    const { data } = await domiciliosService.BuscarPorPais(1)
    setProvincias(data)
  }

  useEffect(() => {
    obtenerProvincias()
  }, [])

  const recalcularMonto = (base, alicuota) => (base * alicuota) / 100

  const calcularBaseDesdeItems = (itemsBaseIds) => {
    const ids = new Set(itemsBaseIds ?? [])
    return (pedidoItems ?? []).reduce((acc, item) => {
      if (!ids.has(item.idPedidoItem)) {
        return acc
      }
      const neto = obtenerNetoItem?.(item) ?? 0
      return acc + (isFinite(neto) ? neto : 0)
    }, 0)
  }

  const toggleItemBase = (index, idPedidoItem) => {
    const copia = [...(filas ?? [])]
    const fila = { ...copia[index] }

    const set = new Set(fila.itemsBaseIds ?? [])
    if (set.has(idPedidoItem)) {
      set.delete(idPedidoItem)
    } else {
      set.add(idPedidoItem)
    }

    fila.itemsBaseIds = Array.from(set)

    const base = calcularBaseDesdeItems(fila.itemsBaseIds)
    fila.baseImponible = base

    fila.monto = Number.isFinite(fila.alicuota) ? recalcularMonto(base, fila.alicuota) : 0

    copia[index] = fila
    onChangeFilas?.(copia)
  }

  const handleChange = (index, campo, valor) => {
    const copia = [...(filas ?? [])]
    const fila = { ...copia[index] }

    if (campo === 'idProvincia') {
      fila.idProvincia = valor
      const prov = provincias.find((p) => String(p.idProvincia) === String(valor))
      fila.nombreProvincia = prov?.nombre || fila.nombreProvincia || ''
    }

    if (campo === 'alicuota') {
      fila.alicuota = valor === '' ? '' : Number(valor)
    }

    const base = fila.existente
      ? Number(fila.baseImponible || 0)
      : calcularBaseDesdeItems(fila.itemsBaseIds)

    fila.baseImponible = base

    fila.monto = Number.isFinite(fila.alicuota) ? recalcularMonto(base, fila.alicuota) : 0

    copia[index] = fila
    onChangeFilas?.(copia)
  }

  const agregarFila = () => {
    const todosLosIds = (pedidoItems ?? []).map((item) => item.idPedidoItem)
    const baseInicial = calcularBaseDesdeItems(todosLosIds)

    const nueva = {
      idFila: generarIdTemporal(),
      idProvincia: '',
      nombreProvincia: '',
      alicuota: '',
      tipoImpuesto: TIPO_IMPUESTO_PERCEPCION,
      baseImponible: baseInicial,
      monto: 0,
      itemsBaseIds: todosLosIds,
      existente: false,
      pendienteEliminar: false
    }
    onChangeFilas?.([...(filas ?? []), nueva])
  }

  const eliminarFila = (fila) => {
    const copia = (filas ?? []).map((f) =>
      f.existente && f.idProvincia === fila.idProvincia
        ? { ...f, pendienteEliminar: true }
        : f
    )
    onChangeFilas?.(copia)
  }

  const cancelarEliminacion = (fila) => {
    const copia = (filas ?? []).map((f) =>
      f.pendienteEliminar && f.idProvincia === fila.idProvincia
        ? { ...f, pendienteEliminar: false }
        : f
    )
    onChangeFilas?.(copia)
  }

  const quitarFilaNueva = (index) => {
    onChangeFilas?.((filas ?? []).filter((_, i) => i !== index))
    setErrores({})
  }

  if (!esVentas && (filas ?? []).length === 0) {
    return null
  }

  const habilitarAgregarPercepciones = pedidoItems.some(
    (item) =>
      item.idPedidoItemEstado === ESTADO_PERCEPCIONES_OK ||
      item.idPedidoItemEstado === ESTADO_PERCEPCIONES_NO_OK
  )

  return (
    <div>
      {!esVentas ? (
        <>
          {(filas ?? []).map((fila, index) => (
            <div key={index} className={detallePrecioStyles.itemRow}>
              {usaImagen && <div className={detallePrecioStyles.itemImagen}></div>}
              <div
                className={`${detallePrecioStyles.itemTitulo} ${styles.tituloImpuesto}`}
              >
                <strong>IIBB {fila.nombreProvincia}</strong>
                <span className={styles.alicuotaLectura}>{fila.alicuota}%</span>
              </div>
              <div
                className={`${detallePrecioStyles.itemCantidad} ${styles.cantidadOculta}`}
              ></div>
              <div
                className={`${detallePrecioStyles.itemPrecio} ${styles.precioConBotones}`}
              >
                <Precios
                  nombre=""
                  precio={fila.monto}
                  monedaSimbolo="$"
                  alicuota={0}
                  cantidad={1}
                  showSinIVA={false}
                />
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          {(filas ?? []).map((fila, index) => {
            const key = fila.idFila || `${fila.idProvincia}_${index}`
            const baseSeleccionada = !fila.existente
              ? calcularBaseDesdeItems(fila.itemsBaseIds)
              : fila.baseImponible || 0
            return (
              <div key={key}>
                <div
                  className={`${detallePrecioStyles.itemRow} ${
                    fila.pendienteEliminar ? styles.filaEliminada : ''
                  }`}
                >
                  {usaImagen && <div className={detallePrecioStyles.itemImagen}></div>}
                  <div
                    className={`${detallePrecioStyles.itemTitulo} ${styles.tituloImpuesto}`}
                  >
                    {fila.existente ? (
                      <>
                        <strong>IIBB {fila.nombreProvincia}</strong>
                        {!fila.pendienteEliminar ? (
                          <div className={styles.alicuotaEditable}>
                            <input
                              type="number"
                              min="0"
                              max={ALICUOTA_MAX}
                              step="0.01"
                              value={fila.alicuota}
                              disabled={!habilitarAgregarPercepciones}
                              onChange={(e) =>
                                handleChange(index, 'alicuota', e.target.value)
                              }
                              className={styles.inputAlicuota}
                            />
                            <span className={styles.porcentaje}>%</span>
                          </div>
                        ) : (
                          <span className={styles.textoEliminada}>
                            Marcada para eliminar
                          </span>
                        )}
                      </>
                    ) : (
                      <>
                        <div className={styles.nuevaPercepcion}>
                          <GenericSelect
                            options={(provincias ?? []).map((prov) => ({
                              value: prov.idProvincia,
                              label: prov.nombre,
                              key: prov.idProvincia
                            }))}
                            value={fila.idProvincia}
                            onChange={(value) =>
                              handleChange(index, 'idProvincia', value)
                            }
                            placeholder="Seleccionar provincia"
                          />
                          <div className={styles.alicuotaEditable}>
                            <input
                              type="number"
                              min="0"
                              max={ALICUOTA_MAX}
                              step="0.01"
                              placeholder="0"
                              value={fila.alicuota}
                              onChange={(e) =>
                                handleChange(index, 'alicuota', e.target.value)
                              }
                              className={styles.inputAlicuota}
                            />
                            <span className={styles.porcentaje}>%</span>
                          </div>
                        </div>
                        <div className={styles.itemsBaseBox}>
                          <div className={styles.itemsBaseTitle}>
                            Base imponible (seleccioná ítems)
                          </div>
                          {pedidoItems.map((it) => {
                            const checked = (fila.itemsBaseIds ?? []).includes(
                              it.idPedidoItem
                            )
                            const neto = Number(obtenerNetoItem?.(it) ?? 0)
                            return (
                              <label key={it.idPedidoItem} className={styles.itemBaseRow}>
                                <input
                                  type="checkbox"
                                  checked={checked}
                                  onChange={() => toggleItemBase(index, it.idPedidoItem)}
                                />
                                <span className={styles.itemBaseText}>
                                  #{it.idPedidoItem} — {it.titulo} — Neto:{' '}
                                  {Number.isFinite(neto) ? `$${neto}` : '$0.00'}
                                </span>
                              </label>
                            )
                          })}
                          <div className={styles.baseSeleccionada}>
                            Base seleccionada:{' '}
                            <strong>${Number(baseSeleccionada || 0)}</strong>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`${detallePrecioStyles.itemCantidad} ${styles.cantidadOculta}`}
                  ></div>
                  <div
                    className={`${detallePrecioStyles.itemPrecio} ${styles.precioConBotones}`}
                  >
                    <Precios
                      nombre=""
                      precio={fila.monto}
                      monedaSimbolo="$"
                      alicuota={0}
                      cantidad={1}
                      showSinIVA={false}
                    />
                    {habilitarAgregarPercepciones &&
                      (fila.existente ? (
                        !fila.pendienteEliminar ? (
                          <button
                            type="button"
                            onClick={() => eliminarFila(fila)}
                            title="Marcar para eliminar"
                            className={styles.btnEliminar}
                          >
                            <i className="bi bi-trash" />
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() => cancelarEliminacion(fila)}
                            title="Cancelar eliminación"
                            className={styles.btnCancelar}
                          >
                            <i className="bi bi-arrow-counterclockwise" />
                          </button>
                        )
                      ) : (
                        <button
                          type="button"
                          onClick={() => quitarFilaNueva(index)}
                          title="Quitar"
                          className={styles.btnCancelar}
                        >
                          -
                        </button>
                      ))}
                  </div>
                </div>
                {['provincia', 'alicuota', 'items'].map(
                  (campo) =>
                    errores?.[`${campo}_${index}`] && (
                      <small key={campo} className={styles.errorInline}>
                        {errores[`${campo}_${index}`]}
                      </small>
                    )
                )}
              </div>
            )
          })}
          {habilitarAgregarPercepciones && (
            <button type="button" onClick={agregarFila} className={styles.btnAgregar}>
              + Agregar percepción
            </button>
          )}
        </>
      )}
    </div>
  )
}

DetalleImpuestos.propTypes = {
  esVentas: PropTypes.bool,
  filas: PropTypes.arrayOf(
    PropTypes.shape({
      rowKey: PropTypes.string,
      idFila: PropTypes.string,
      idProvincia: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      nombreProvincia: PropTypes.string,
      alicuota: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      tipoImpuesto: PropTypes.string,
      baseImponible: PropTypes.number,
      monto: PropTypes.number,
      itemsBaseIds: PropTypes.arrayOf(PropTypes.number),
      existente: PropTypes.bool,
      pendienteEliminar: PropTypes.bool
    })
  ),
  onChangeFilas: PropTypes.func,
  errores: PropTypes.object,
  usaImagen: PropTypes.bool,
  pedidoItems: PropTypes.array,
  obtenerNetoItem: PropTypes.func,
  setErrores: PropTypes.func
}
